import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { Card } from './ui/Card';
export function Testimonials() {
  return <section className="py-20 bg-gray-900 text-white relative overflow-hidden" data-id="element-195">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-196">
        <div className="absolute top-10 left-10 w-64 h-64 bg-red-600 rounded-full blur-3xl" data-id="element-197"></div>
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-amber-500 rounded-full blur-3xl" data-id="element-198"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-199">
        <div className="text-center mb-16" data-id="element-200">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-4" data-id="element-201">
            What <span className="text-amber-400" data-id="element-202">Teachers</span> Are Saying
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-203">
            Fellow educators who have already transformed their classes with the
            Toolkit.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-204">
          {/* Testimonial 1 */}
          <Card className="bg-white border-gray-200 p-8 relative" data-id="element-205">
            <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-gray-300 opacity-50" data-id="element-206" />
            <div className="flex items-center gap-4 mb-6" data-id="element-207">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-500 to-amber-500 flex items-center justify-center text-xl font-bold text-white" data-id="element-208">
                L
              </div>
              <div data-id="element-209">
                <h4 className="font-bold text-gray-900" data-id="element-210">Laura G.</h4>
                <p className="text-sm text-gray-500" data-id="element-211">
                  Elementary Drama Teacher
                </p>
              </div>
            </div>
            <p className="text-gray-900 italic leading-relaxed" data-id="element-212">
              "Incredible resource! It saved my entire school year. The warm-up
              activities are so much fun and my students absolutely love them.
              Highly recommend to every drama teacher."
            </p>
          </Card>

          {/* Testimonial 2 */}
          <Card className="bg-white border-gray-200 p-8 relative" data-id="element-213">
            <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-gray-300 opacity-50" data-id="element-214" />
            <div className="flex items-center gap-4 mb-6" data-id="element-215">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-500 to-amber-500 flex items-center justify-center text-xl font-bold text-white" data-id="element-216">
                M
              </div>
              <div data-id="element-217">
                <h4 className="font-bold text-gray-900" data-id="element-218">Martin R.</h4>
                <p className="text-sm text-gray-500" data-id="element-219">
                  High School Theater Director
                </p>
              </div>
            </div>
            <p className="text-gray-900 italic leading-relaxed" data-id="element-220">
              "The high school section is incredibly thorough. The production
              projects are structured step by step — my students went from
              nervous to confident performers. Excellent investment."
            </p>
          </Card>

          {/* Testimonial 3 */}
          <Card className="bg-white border-gray-200 p-8 relative" data-id="element-221">
            <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-gray-300 opacity-50" data-id="element-222" />
            <div className="flex items-center gap-4 mb-6" data-id="element-223">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-red-500 to-amber-500 flex items-center justify-center text-xl font-bold text-white" data-id="element-224">
                S
              </div>
              <div data-id="element-225">
                <h4 className="font-bold text-gray-900" data-id="element-226">Sophia P.</h4>
                <p className="text-sm text-gray-500" data-id="element-227">
                  Independent Drama Workshop Instructor
                </p>
              </div>
            </div>
            <p className="text-gray-900 italic leading-relaxed" data-id="element-228">
              "I use the bonus resources every single class. The warm-up bank is
              endless. It lets me keep every session fresh and my students
              always engaged and excited."
            </p>
          </Card>
        </div>
      </div>
    </section>;
}